import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { Locker } from '@sorare/core/src/atoms/icons/Locker';
import { glossary } from '@sorare/core/src/lib/glossary';

import { CreateSquadDialog } from 'components/rivals/squads/CreateSquadDialog';

type Props = { creationLocked: boolean };
export const CreateSquadButton = ({ creationLocked }: Props) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <>
      <Button
        color={creationLocked ? 'tertiary' : 'primary'}
        size="large"
        disabled={creationLocked}
        onClick={() => setDialogOpen(true)}
      >
        {creationLocked && <Locker width={16} height={16} />}
        <FormattedMessage {...glossary.create} />
      </Button>
      <CreateSquadDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};
